import LTR from "@brand-icons/global/social-line/social-line-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SocialLineIcon = iconFactory("SocialLineIcon", LTR);
